/** Forms page_configuration capability flags (/forms). */

const FORMS_VIEW_SCOPES = Object.freeze({
  OWN: 'own',
  ORGANIZATION: 'organization',
  ALL: 'all'
});

const FORMS_TAXONOMY_SCOPES = Object.freeze({
  OWN_ORGANIZATION: 'own_organization',
  ALL_ORGANIZATIONS: 'all_organizations'
});

function isConfigFlagTrue(value) {
  return value === true;
}

function normalizeFormsViewScope(value) {
  const v = String(value || '')
    .trim()
    .toLowerCase();
  if (v === FORMS_VIEW_SCOPES.ORGANIZATION || v === 'org') return FORMS_VIEW_SCOPES.ORGANIZATION;
  if (v === FORMS_VIEW_SCOPES.ALL) return FORMS_VIEW_SCOPES.ALL;
  return FORMS_VIEW_SCOPES.OWN;
}

function normalizeFormsTaxonomyScope(value) {
  const v = String(value || '')
    .trim()
    .toLowerCase();
  if (v === FORMS_TAXONOMY_SCOPES.ALL_ORGANIZATIONS || v === 'all') {
    return FORMS_TAXONOMY_SCOPES.ALL_ORGANIZATIONS;
  }
  return FORMS_TAXONOMY_SCOPES.OWN_ORGANIZATION;
}

/**
 * @param {object|null|undefined} configuration
 */
export function getFormsPageCapabilities(configuration) {
  const cfg = configuration && typeof configuration === 'object' ? configuration : {};
  return {
    viewScope: normalizeFormsViewScope(cfg.forms_view_scope),
    taxonomyScope: normalizeFormsTaxonomyScope(cfg.forms_taxonomy_scope),
    canCreate: isConfigFlagTrue(cfg.can_create_forms),
    canEdit: isConfigFlagTrue(cfg.can_edit_forms),
    canDelete: isConfigFlagTrue(cfg.can_delete_forms),
    canAssign: isConfigFlagTrue(cfg.can_assign_forms)
  };
}

export { FORMS_VIEW_SCOPES, FORMS_TAXONOMY_SCOPES };
